"use strict";
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKColorRange = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var hooks_1 = require("../../../common/hooks");
var components_1 = require("../../../components");
var models_1 = require("../../../models");
var services_1 = require("../../../services");
require("./GKColorRange.css");
var LegendKey = React.memo(function LegendKey(props) {
    // const legendCtx = React.useContext(GKColorLegendContext);
    var _a = (0, common_1.mapDefaultProps)(props, { _gkComponentName: "gk-color-range--key" }), color = _a.color, qaProp = _a["data-qa"], width = _a.width, payload = _a.payload, primary = _a.primary, secondary = _a.secondary, tooltip = _a.tooltip, tooltipPlacement = _a.tooltipPlacement, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onSelection = _a.onSelection, selection = _a.selection, type = _a.type, otherProps = __rest(_a, ["color", "data-qa", "width", "payload", "primary", "secondary", "tooltip", "tooltipPlacement", "onClick", "onMouseEnter", "onMouseLeave", "onSelection", "selection", "type"]);
    var handleSelect = function () {
        if (onSelection) {
            var newSelect = new Set(selection);
            if (!newSelect.delete(payload)) {
                newSelect.add(payload);
            }
            onSelection(Array.from(newSelect));
        }
    };
    var legendRef = React.useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({}, otherProps, { "data-qa": qaProp, onClick: function () {
                onClick === null || onClick === void 0 ? void 0 : onClick(payload);
                type === "discrete" && handleSelect();
            }, onMouseEnter: function () { return onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(payload); }, onMouseLeave: function () { return onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(payload); }, style: { width: width }, ref: legendRef }),
            React.createElement("div", { className: "key-primary" }, primary),
            type === "discrete" && (React.createElement("div", { "data-qa": qaProp + "--color", className: "gk-color-discrete-color-line p-2", style: { backgroundColor: color } })),
            React.createElement("div", { className: "key-secondary" }, secondary)),
        tooltip && (React.createElement(components_1.GKTooltip, { target: legendRef, placement: tooltipPlacement }, tooltip))));
});
var GKColorRange = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-color-range",
    }), qaProp = _a["data-qa"], discreteKeyWidth = _a.discreteKeyWidth, id = _a.id, keys = _a.keys, limitToPalette = _a.limitToPalette, onSelection = _a.onSelection, _b = _a.orientation, orientation = _b === void 0 ? models_1.Orientation.Horizontal : _b, _c = _a.palette, palette = _c === void 0 ? models_1.ColorRange.Stoplight : _c, reverse = _a.reverseColor, selection = _a.selection, _d = _a.type, type = _d === void 0 ? "continuous" : _d, otherProps = __rest(_a, ["data-qa", "discreteKeyWidth", "id", "keys", "limitToPalette", "onSelection", "orientation", "palette", "reverseColor", "selection", "type"]);
    var _e = React.useState([]), colors = _e[0], setColors = _e[1];
    var _f = React.useState(""), gradient = _f[0], setGradient = _f[1];
    var uniqueId = (0, hooks_1.usePersistentId2)(id);
    // const legendCtx = React.useContext(GKColorLegendContext);
    var stops = (keys === null || keys === void 0 ? void 0 : keys.length) || palette.length;
    // Update colors.
    React.useEffect(function () {
        var newColors = services_1.colorService.getDiscreteRange({
            stops: stops,
            palette: palette,
            reverse: reverse,
            limitToPalette: limitToPalette,
        });
        var newGradient = services_1.colorService.getCssGradient({
            direction: orientation === models_1.Orientation.Vertical ? "to bottom" : undefined,
            palette: palette,
            reverse: reverse,
        });
        setColors(newColors);
        setGradient(newGradient);
    }, [orientation, limitToPalette, palette, stops, reverse]);
    // Renderer for "continuous" (gradient) color range.
    var renderContinuous = function () {
        // Set up all our classes.
        var containerClasses = ["gk-color-range-continuous d-flex"];
        var rangeClasses = ["gk-color-range-keys d-flex w-100"];
        var keyClasses = [
            "gk-color-range-key text-center d-flex justify-content-between",
        ];
        if (orientation === models_1.Orientation.Horizontal) {
            containerClasses.push("horizontal-range flex-column");
            keyClasses.push("flex-column");
        }
        else {
            containerClasses.push("vertical-range");
            rangeClasses.push("flex-column");
        }
        // Generate the array of keys.
        var renderedKeys = keys === null || keys === void 0 ? void 0 : keys.map(function (key, i) { return (React.createElement(LegendKey, __assign({ key: i, id: uniqueId + "-" + i, className: keyClasses.join(" "), color: String(colors[i]), type: type }, key))); });
        // Return the gradient line and keys.
        return (React.createElement("div", { "data-qa": qaProp + "--range", id: uniqueId + "--range", className: containerClasses.join(" ") },
            React.createElement("div", { "data-qa": qaProp + "--gradient", className: "gk-color-range-gradient-line", style: { backgroundImage: gradient } }),
            React.createElement("div", { className: rangeClasses.join(" ") }, renderedKeys)));
    };
    // Renderer for "discrete" (bucket) color range.
    var renderDiscrete = function () {
        // Set up all our classes
        var containerClasses = ["gk-color-range-discrete d-flex"];
        var keyClasses = ["gk-color-range-key"];
        if (orientation === models_1.Orientation.Vertical) {
            containerClasses.push("vertical-range flex-column");
            keyClasses.push("py-2");
        }
        else {
            containerClasses.push("horizontal-range");
            keyClasses.push("px-3");
        }
        if (discreteKeyWidth) {
            keyClasses.push("key-sized");
        }
        var renderedKeys = keys === null || keys === void 0 ? void 0 : keys.map(function (key, i) { return (React.createElement(LegendKey, __assign({ key: i, id: uniqueId + "-" + i, className: "" + keyClasses.join(" ") + (key.payload && (selection === null || selection === void 0 ? void 0 : selection.includes(key.payload)) ? " selected" : ""), color: String(colors[i]), type: type, width: discreteKeyWidth, selection: selection, onSelection: onSelection }, key))); });
        // Return the wrapped discrete keys.
        return (React.createElement("div", { "data-qa": qaProp + "--range", id: uniqueId + "--range", className: containerClasses.join(" ") }, renderedKeys));
    };
    return (React.createElement("div", __assign({ "data-qa": qaProp, id: uniqueId }, otherProps), type === "continuous" ? renderContinuous() : renderDiscrete()));
};
exports.GKColorRange = GKColorRange;
